import { render, staticRenderFns } from "./PurchaseInvoicesProfileCard.vue?vue&type=template&id=13d406f0&scoped=true&"
import script from "./PurchaseInvoicesProfileCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d406f0",
  null
  
)

export default component.exports